import {
  Avatar,
  Box,
  Card,
  Grid2,
  Paper,
  styled,
  Typography,
} from "@mui/material";
import ContactPulseBeams from "../../ui/ContactPulseBeams";
import ServicesRadar from "../../ui/ServicesRadar";
import CodePreview from "../../ui/CodePreview";
import { motion } from "framer-motion";
import { AnimatedList } from "../../ui/AnimatedList";

const CardContainer = styled(Card)(({ theme }) => ({
  padding: theme.spacing(2),
  position: "relative",
  overflow: "hidden",

  height: 366,
  ":after": {
    content: "''",
    position: "absolute",
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32' width='16' height='16' fill='none'%3e%3ccircle fill='rgb(255 255 255 / 0.2)' cx='10' cy='10' r='1.625'%3e%3c/circle%3e%3c/svg%3e")`,
    backgroundSize: "16px 16px",
    backgroundRepeat: "repeat",
    maskImage:
      "radial-gradient(ellipse at center, rgba(255, 255, 255, 1), transparent 85%)",
  },
}));

const cardVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 },
};

interface Item {
  name: string;
  avatar: string;
  message: string;
}

let reviews = [
  {
    name: "darko_cs16",
    avatar: "",
    message:
      "I experienced a very dedicated man to his craft and a very skillful programmer. I am very happy I was understood well and how this man fulfilled my vision almost entirely. The things I held impossible became quite possible... I promise everyone, that this is the guy for a huge recommendation.",
  },
  {
    name: "Moriel16",
    avatar:
      "https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto,t_profile_small/v1/attachments/profile/photo/4899267899ee56c80413bd5e9d634b22-1701347747277/2f23c795-4e65-4b1e-898d-38fbe06eb58f.jpeg",
    message:
      "I just have no words, the mod turned out amazing, you are a legend, an indescribable professional🤩",
  },
  {
    name: "Majed Aldhahiri",
    avatar: "",
    message:
      "He was very helpful and the results are exceptional",
  },
  {
    name: "Lina B.",
    avatar: "",
    message:
      "Absolutely thrilled with the results! The team really understood my needs and delivered a product that was beyond expectations. They communicated every step of the way and kept me updated throughout the process. I will definitely be coming back for more work in the future!",
  },
  {
    name: "TomW_Dev",
    avatar: "", 
    message:
      "This developer is top-notch! The project was completed ahead of schedule, and the quality was second to none. I appreciated the transparency throughout the entire process, and the team delivered a solution that perfectly matched the scope. Will definitely work with them again!",

  },
  {
    name: "Eva M.",
    avatar: "", 
    message:
      "While the work was good, there were a few small details that I wish had been handled differently. The team was responsive and corrected the issues quickly, but I felt a bit more attention to detail could have been given in the initial stages. Overall, still happy with the results.",
  },
];

reviews = Array.from({ length: 10 }, () => reviews).flat();

const Review = ({ name, avatar, message }: Item) => {
  return (
    <Paper
      sx={{
        display: "flex",
        alignItems: "center",
        p: 1,
      }}
    >
      <Avatar
        src={avatar}
        alt={`${name} avatar`}
        sx={{ width: 40, height: 40, mr: 2 }}
      />
      <Box sx={{ flexGrow: 1, overflow: "hidden" }}>
        <Typography variant="body2" fontWeight="bold" noWrap>
          {name}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
          }}
        >
          {message}
        </Typography>
      </Box>
    </Paper>
  );
};

export default function Features() {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid2 container spacing={2}>
        <Grid2 size={{ xs: 12, md: 5 }}>
          <motion.div
            initial="hidden"
            animate="visible"
            variants={cardVariants}
            transition={{ duration: 0.25, delay: 0.6 }}
          >
            <CardContainer>
              <AnimatedList>
                {reviews.map((item, idx) => (
                  <Review {...item} key={idx} />
                ))}
              </AnimatedList>
            </CardContainer>
          </motion.div>
        </Grid2>

        <Grid2 size={{ xs: 12, md: 7 }}>
          <motion.div
            initial="hidden"
            animate="visible"
            variants={cardVariants}
            transition={{ duration: 0.5, delay: 0.6 }}
          >
            <CardContainer sx={{ p: { xs: 2, sm: 12, md: 6 } }}>
              <ContactPulseBeams />
            </CardContainer>
          </motion.div>
        </Grid2>

        <Grid2 size={{ xs: 12, md: 7 }}>
          <motion.div
            initial="hidden"
            animate="visible"
            variants={cardVariants}
            transition={{ duration: 0.75, delay: 0.6 }}
          >
            <CardContainer>
              <ServicesRadar />
            </CardContainer>
          </motion.div>
        </Grid2>

        <Grid2 size={{ xs: 12, md: 5 }}>
          <motion.div
            initial="hidden"
            animate="visible"
            variants={cardVariants}
            transition={{ duration: 1, delay: 0.6 }}
          >
            <CardContainer>
              <CodePreview />
            </CardContainer>
          </motion.div>
        </Grid2>
      </Grid2>
    </Box>
  );
}
